import React from "react";
import "./AddChargerDataModal.css";
import AddAgencyModalLogo from "../../assets/images/addAgencyModalLogo.svg";
import { Button } from "primereact/button";
import * as yup from "yup";

import "react-phone-input-2/lib/bootstrap.css";
import { useFormik } from "formik";
import { CommonDate, CommonDropdown, CommonInputField } from "../common-input";
import moment from "moment";
import { addChargerData } from "../../services/charger.data.service";
import { useSelector } from "react-redux";
import useToast from "../../context/toast.hook";
import { Toast } from "primereact/toast";
import { TwoSection } from "../common-grid";
import { useMediaQuery } from "react-responsive";

const AddChargerDataModal = ({ toggleModal, allBuses, allChargers }) => {
  const isMobile = useMediaQuery({
    query: "(max-width: 800px)",
  });
  const { errorToast, successToast, toastRef } = useToast();
  const { currentUser } = useSelector((state) => state.user);
  const { allAgencies } = useSelector((state) => state.agencies);

  const schema = yup.object().shape({
    agencyId: yup
      .string()
      .test("requiredForAdmin", "Agency is required", function (value) {
        if (currentUser?.role === "admin") {
          return !!value;
        }
        return true;
      }),
    busId: yup.string().required("Bus is required"),
    chargerId: yup.string().required("charger is required"),
    duration: yup.string(),
    socStart: yup.string(),
    date: yup.string().required("Date is required"),
    socEnd: yup.string(),
    docking: yup.string(),
    undocking: yup.string(),
    power: yup.string(),
    energy: yup.string(),
  });

  const handleSubmit = async (values) => {
    addChargerData({
      ...values,
      date: moment(values.date).format("YYYY-MM-DD"),
    })
      .then((res) => {
        toggleModal();
      })
      .catch((err) => {
        errorToast(err);
      });
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      agencyId: "",
      busId: "",
      chargerId: "",
      duration: "",
      socStart: "",
      date: "",
      socEnd: "",
      docking: "",
      undocking: "",
      power: "",
      energy: "",
    },
    validationSchema: schema,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  return (
    <>
      <Toast ref={toastRef} />
      <div className="modalChargerData">
        <div className="modalInternalsChargerData">
          <img className="logoModal" src={AddAgencyModalLogo} alt="ModalLogo" />
          <br />
          <span className="modalHeading">Add Charging Episode Data</span>

          <div className="inputFieldBoxChargerData">
            <div className="noBusesBoxChargerData">
              {currentUser?.role === "admin" && (
                <div className="noBoxChargerData">
                  <strong>Select Agency</strong>
                  <br />
                  <CommonDropdown
                    formik={formik}
                    name="agencyId"
                    optionArray={allAgencies}
                    optionKey="_id"
                    optionLabel="name"
                    placeholder="Select Agency"
                    label="Agency"
                    style={{
                      marginTop: "7px",
                      width: !isMobile ? "235px" : "100%",
                    }}
                    formikChange={(e) => {
                      formik.handleChange(e);
                      formik.setFieldValue("busId", "");
                      formik.setFieldValue("chargerId", "");
                    }}
                  />
                </div>
              )}
            </div>
            <TwoSection
              firstLabel="Select Charger"
              firstSection={
                <CommonDropdown
                  formik={formik}
                  name="chargerId"
                  optionArray={
                    currentUser?.role === "admin"
                      ? allChargers?.filter(
                          (charger) =>
                            charger.agencyId === formik.values.agencyId
                        )
                      : allChargers?.filter((charger) =>
                          charger.agencyId === currentUser?.parentId
                            ? currentUser?.parentId
                            : currentUser?._id
                        )
                  }
                  optionKey="_id"
                  optionLabel="chargerNumberPlate"
                  placeholder="Select Charger"
                  label="Charger"
                  style={{
                    marginTop: "7px",
                    width: !isMobile ? "235px" : "100%",
                  }}
                />
              }
              secondLabel="Select Bus"
              secondSection={
                <CommonDropdown
                  name="busId"
                  formik={formik}
                  optionArray={
                    currentUser?.role === "admin"
                      ? allBuses?.filter(
                          (bus) =>
                            bus.agencyId === formik.values.agencyId &&
                            ["BEB", "FC"].includes(bus.technology)
                        )
                      : allBuses?.filter((bus) =>
                          bus.agencyId === currentUser?.parentId
                            ? currentUser?.parentId
                            : currentUser?._id
                        )
                  }
                  optionKey="_id"
                  optionLabel="busNumberPlate"
                  placeholder="Select Bus"
                  label="Bus"
                  style={{
                    marginTop: "7px",
                    height: "40px",
                    width: !isMobile ? "235px" : "100%",
                  }}
                />
              }
            />

            <TwoSection
              firstLabel="Energy Transferred (kWh)"
              firstSection={
                <CommonInputField
                  formik={formik}
                  style={{
                    width: !isMobile ? "235px" : "100%",
                    marginTop: "7px",
                    backgroundColor: "#F9F9F9",
                  }}
                  placeholder="100kWh"
                  name="energy"
                  type="number"
                />
              }
              secondLabel="SOC Start (%)"
              secondSection={
                <CommonInputField
                  formik={formik}
                  style={{
                    width: !isMobile ? "235px" : "100%",
                    marginTop: "7px",
                    backgroundColor: "#F9F9F9",
                  }}
                  placeholder="30%"
                  name="socStart"
                  type="number"
                  isPercentage
                />
              }
            />

            <TwoSection
              firstLabel="SOC End (%)"
              firstSection={
                <CommonInputField
                  formik={formik}
                  style={{
                    width: !isMobile ? "235px" : "100%",
                    marginTop: "7px",
                    backgroundColor: "#F9F9F9",
                  }}
                  placeholder="40%"
                  name="socEnd"
                  type="number"
                  isPercentage
                />
              }
              secondLabel="Average Power (kW)"
              secondSection={
                <CommonInputField
                  formik={formik}
                  style={{
                    width: !isMobile ? "235px" : "100%",
                    marginTop: "7px",
                    backgroundColor: "#F9F9F9",
                  }}
                  placeholder="100kW"
                  name="power"
                  type="number"
                />
              }
            />

            <TwoSection
              firstLabel="Docking (s)"
              firstSection={
                <CommonInputField
                  formik={formik}
                  style={{
                    width: !isMobile ? "235px" : "100%",
                    marginTop: "7px",
                    backgroundColor: "#F9F9F9",
                  }}
                  placeholder="100s"
                  name="docking"
                  type="number"
                />
              }
              secondLabel="Undocking (s)"
              secondSection={
                <CommonInputField
                  formik={formik}
                  style={{
                    width: !isMobile ? "235px" : "100%",
                    marginTop: "7px",
                    backgroundColor: "#F9F9F9",
                  }}
                  placeholder="100s"
                  name="undocking"
                  type="number"
                />
              }
            />

            <TwoSection
              firstLabel="Duration (s)"
              firstSection={
                <CommonInputField
                  formik={formik}
                  style={{
                    width: !isMobile ? "235px" : "100%",
                    marginTop: "7px",
                    backgroundColor: "#F9F9F9",
                  }}
                  placeholder="50s"
                  name="duration"
                  type="number"
                />
              }
              secondLabel="Date"
              secondSection={
                <CommonDate
                  placeholder="Click here to select a date"
                  formik={formik}
                  name="date"
                  style={{
                    marginTop: "7px",
                  }}
                  isNew={true}
                />
              }
            />
          </div>

          <div className="addBackBoxChargerData">
            <div className="addButton">
              <Button
                label="Add"
                style={{ background: "#1C9894", width: "140px", border: "0" }}
                onClick={formik.handleSubmit}
              />
            </div>
            <div className="addButton">
              <Button
                label="Back"
                style={{
                  background: "#FFFFFF",
                  width: "140px",
                  color: "#1C9894",
                  marginLeft: "20px",
                  borderColor: "#1C9894",
                }}
                onClick={() => {
                  toggleModal(true);
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div
        className="overlay"
        onClick={() => {
          toggleModal(true);
        }}
      ></div>
    </>
  );
};

export default AddChargerDataModal;
